import { DependsOnIfEnum } from "@generation/schema-core/src/client/enums/dependsOnIfEnum";
import { DependsOnThenEnum } from "@generation/schema-core/src/client/enums/dependsOnThenEnum";
import { IDependsOn } from "@generation/schema-core/src/client/model/dependsOn";
import { SelectFieldOrderBy } from "@generation/schema-core/src/client/model/options/selectFieldOrderByEnum";
import { ISimpleForm } from "@klantondersteuning/shared/src/form/interface/SimpleForm/ISimpleForm";
import { PredefinedFieldType } from "@klantondersteuning/shared/src/form/interface/SimpleForm/PredefinedFieldType";
import { RegelingOptions } from "@klantondersteuning/shared/src/form/interface/SimpleForm/RegelingOptions";
import { translate } from "@opencak-klantondersteuning/shared";

const dependsOnShowIfIemandAnders: IDependsOn[] = [
  {
    property: "stap_klachtomschrijving__klachtomschrijving.voorwie",
    if: DependsOnIfEnum.IsNotEqualToValue,
    value: "voorander",
    then: DependsOnThenEnum.Hide,
    isAbsolutePath: true
  }
];

const dependsOnHideIfIemandAnders: IDependsOn[] = [
  {
    property: "stap_klachtomschrijving__klachtomschrijving.voorwie",
    if: DependsOnIfEnum.IsEqualToValue,
    value: "voorander",
    then: DependsOnThenEnum.Hide,
    isAbsolutePath: true
  }
];

const dependsOnShowIfRegelingBuitenland: IDependsOn[] = [
  {
    property: "stap_klachtomschrijving__klachtomschrijving.regeling",
    if: DependsOnIfEnum.IsNotEqualToValue,
    value: RegelingOptions.Buitenland,
    then: DependsOnThenEnum.Hide,
    isAbsolutePath: true
  }
];

export const GetSimpleKlachtFormulier = (): ISimpleForm => {
  return {
    name: "klachten-formulier",
    steps: [
      {
        name: translate("KlachtFormulierStapInleiding"),
        isIntroduction: true
      },
      {
        name: translate("KlachtFormulierStapMijnKlacht"),
        Sections: [
          {
            name: "stap_klachtomschrijving__klachtomschrijving",
            fields: {
              voorwie: {
                type: "radio",
                options: [
                  {
                    label: translate("VoorMijzelf"),
                    value: "voormijzelf"
                  },
                  {
                    label: translate("VoorIemandAnders"),
                    value: "voorander"
                  }
                ],
                ui: {
                  flexDirection: "column"
                },
                validate: {
                  isRequired: {
                    value: true
                  }
                }
              },
              regeling: {
                predefinedFieldType: PredefinedFieldType.regeling,
                isRequired: true,
                regelingOptions: [
                  RegelingOptions.BeschermdWonen,
                  RegelingOptions.MedicijnenMeeOpReis,
                  RegelingOptions.Gemoedsbezwaarden,
                  RegelingOptions.Onverzekerden,
                  RegelingOptions.BetalingsachterstandZorgpremie,
                  RegelingOptions.Wlz,
                  RegelingOptions.WmoAT,
                  RegelingOptions.Buitenland,
                  RegelingOptions.Onbekend
                ],
                orderOptionsBy: {
                  orderBy: SelectFieldOrderBy.Alphabetical,
                  exclusions: [RegelingOptions.Onbekend]
                }
              },
              klantId: {
                predefinedFieldType: PredefinedFieldType.cakKenmerk
              },
              klacht: {
                predefinedFieldType: PredefinedFieldType.textArea,
                isRequired: true
              },
              bijlage: {
                predefinedFieldType: PredefinedFieldType.bijlage
              }
            }
          }
        ]
      },
      {
        name: translate("MijnGegevens"),
        Sections: [
          {
            name: "stap_contactgegevens__contactgegevens",
            fields: {
              voorletters: {
                predefinedFieldType: PredefinedFieldType.voorletters,
                isRequired: true
              },
              achternaam: {
                predefinedFieldType: PredefinedFieldType.achternaam,
                isRequired: true,
                autoComplete: true
              },
              geboortenaam: {
                predefinedFieldType: PredefinedFieldType.geboortenaam,
                dependsOn: [...dependsOnShowIfRegelingBuitenland, ...dependsOnHideIfIemandAnders]
              },
              geboortedatum: {
                predefinedFieldType: PredefinedFieldType.geboortedatum,
                isRequired: true,
                dependsOn: dependsOnHideIfIemandAnders
              },
              bsn: {
                predefinedFieldType: PredefinedFieldType.bsn,
                dependsOn: dependsOnHideIfIemandAnders
              },
              email: {
                predefinedFieldType: PredefinedFieldType.email,
                isRequired: true,
                autoComplete: true
              },
              telefoonnummer: {
                predefinedFieldType: PredefinedFieldType.telefoonnummer,
                autoComplete: true
              }
            }
          },
          {
            name: "stap_contactgegevens__voorWieGegevens",
            fields: {
              voorWieGegevensVoorletters: {
                predefinedFieldType: PredefinedFieldType.voorletters,
                isRequired: true
              },
              voorWieGegevensAchternaam: {
                predefinedFieldType: PredefinedFieldType.achternaam,
                isRequired: true
              },
              voorWieGegevensGeboortenaam: {
                predefinedFieldType: PredefinedFieldType.geboortenaam,
                dependsOn: dependsOnShowIfRegelingBuitenland
              },
              voorWieGeboorteDatum: {
                predefinedFieldType: PredefinedFieldType.geboortedatum,
                isRequired: true
              },
              voorWieBsn: {
                predefinedFieldType: PredefinedFieldType.bsn
              }
            },
            dependsOn: dependsOnShowIfIemandAnders
          }
        ]
      }
    ]
  };
};
